const commonConstants = {
  GLOBAL_LOADING_START: "GLOBAL_LOADING_START",
  GLOBAL_LOADING_ENDED: "GLOBAL_LOADING_ENDED",
  FETCH_START: "FETCH_START",
  FETCH_SUCCESS: "FETCH_SUCCESS",
  FETCH_ERROR: "FETCH_ERROR",
  SUCCESSFUL_CODE: "00",
};

export default commonConstants;
